<div class="flex flex-col justify-center items-center px-4 py-16 text-center">
  <h1 class="text-6xl font-bold text-gray-900 dark:text-white mb-4">404</h1>
  <div class="text-gray-600 dark:text-gray-400 mb-6">
    <h2 class="text-2xl font-semibold mb-2">Page Not Found</h2>
    <p>The page you're looking for doesn't exist or has been moved.</p>
  </div>
  <div class="flex flex-col sm:flex-row gap-4">
    <a routerLink="/" hlmBtn>Return to Home</a>
    <a routerLink="/about" hlmBtn variant="outline">About Summerry</a>
  </div>
</div>
